import {View} from 'MWC';
import tpl from '..//templates/main';
import {list} from '../../../../../list';

export default class extends View {
    constructor(props) {
        super(props);
        this.state = {
            subMenuAbout: list.subMenuAbout,
            subMenuCards: list.subMenuCards,
            subMenuCredit: list.subMenuCredit,
            subMenuBusiness: list.subMenuBusiness,
            subMenuServices: list.subMenuServices,
            menuHeaderItem: list.menuHeaderItem,

            subMenuCards2: list.subMenuCards2,
            subMenuCredit2: list.subMenuCredit2,
            subMenuDeposits2: list.subMenuDeposits2,
            subMenuBusiness2: list.subMenuBusiness2,
            subMenuServices2: list.subMenuServices2,
            subMenuServices3: list.subMenuServices3
        };
    }
    template = tpl;

    state = {
        isOpened: false
    };

    componentDidMount() {
        this.setState({headerMenuList: Object.values(this.state.menuHeaderItem)});
    }

    toggle = () => {
        this.closeAllSubMenuItem();
        return this.setState({isOpened: !this.state.isOpened});
    };

    home = e => {
        this.props.navigate('/', e);
        if (this.state.isOpened) {
            this.toggle();
        }
    };

    closeAllSubMenuItem = () => {
        this.state.headerMenuList.map(item => {
            this.setState({[`${item}Hover`]: false});
        });
    };

    toggleSubMenuItemHover = name => {
        this.state.headerMenuList.map(item => {
            item === name
                ? this.setState({[`${name}Hover`]: !this.state[`${name}Hover`]})
                : this.setState({[`${item}Hover`]: false});
        });
    };

    static displayName = 'Header.Views.MobileCreditsMenu';
}
